<template>
  <v-dialog v-model="visible" max-width="500" persistent>
    <v-card>
      <v-card-title>
        <v-icon left color="primary">mdi-truck-plus</v-icon>
        {{ $t("importarProductos.newProveedorTitle") }}
      </v-card-title>

      <v-card-text>
        <v-form ref="formRef" @submit.prevent="crear">
          <proveedor-form
            ref="form"
            v-model="form"
            :input-errors="inputErrors"
            stacked
          />

          <v-alert v-if="errorMessage" type="error" dense>
            {{ errorMessage }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cerrar">
          {{ $t("importarProductos.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click="crear"
        >
          <v-icon left>mdi-check</v-icon>
          {{ $t("importarProductos.createProveedorAndUse") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProveedorForm from "../../../proveedor/pages/ProveedorManagementPage/ProveedorForm/ProveedorForm.vue";
import ProveedorProvider from "../../../proveedor/providers/ProveedorProvider";
import ClientError from "@/errors/ClientError";

export default {
  name: "NuevoProveedorModal",
  components: { ProveedorForm },
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      inputErrors: {},
      form: {
        nombre: null,
        cuit: null,
        email: null,
        telefono: null,
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        nombre: null,
        cuit: null,
        email: null,
        telefono: null,
      };
      this.errorMessage = "";
      this.inputErrors = {};
      this.$nextTick(() => this.$refs.formRef?.resetValidation());
    },
    cerrar() {
      this.$emit("input", false);
    },
    crear() {
      this.$refs.form?.validateThenConfirm(() => {
        this.performCrear();
      });
    },
    async performCrear() {
      this.loading = true;
      this.errorMessage = "";
      this.inputErrors = {};
      try {
        const res = await ProveedorProvider.createProveedor(this.form);
        const proveedor = res?.data?.proveedorCreate;
        if (proveedor) {
          this.$emit("created", proveedor);
          this.cerrar();
        }
      } catch (error) {
        const clientError = new ClientError(error);
        this.inputErrors = clientError.inputErrors || {};
        this.errorMessage = clientError.i18nMessage || "Error al crear proveedor";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

